import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/** Boolean on/off switch (ARIA switch). Works with formControlName / ngModel. */
@Component({
  selector: 'app-toggle-switch',
  standalone: false,
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ToggleSwitchComponent), multi: true }],
})
export class ToggleSwitchComponent implements ControlValueAccessor {
  @Input() inputId?: string;
  @Input() labelledBy?: string;
  @Input() describedBy?: string;

  checked = false;
  disabled = false;
  private onChange: (v: boolean) => void = () => { };
  private onTouched: () => void = () => { };

  writeValue(v: boolean): void { this.checked = !!v; }
  registerOnChange(fn: (v: boolean) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.disabled = isDisabled; }

  // A native <button> already fires click on Space/Enter, so keyboard support comes for free.
  toggle(): void {
    if (this.disabled) return;
    this.checked = !this.checked;
    this.onChange(this.checked);
  }

  onBlur(): void { this.onTouched(); }
}
